module.exports = __webpack_public_path__ + "static/media/RMS-korisnicko-uputstvo.b0ddf335.pdf";